import Empresa from './Empresa';
import Permissao from './Permissao';

/**
 * Modelo dos dados de um avaliador
 */
class Avaliador {

    /**
     * Cria uma nova instância de avaliador
     * @param {Number} id Identificação do avaliador
     * @param {String} nome Nome do avaliador
     * @param {String} email Email do avaliador
     * @param {String} telefone Telefone do avaliador
     * @param {String} senha Senha do avaliador
     * @param {Array<Permissao>} permissoes Lista de permissões do avaliador
     * @param {Empresa} empresa Empresa relacionada ao avaliador
     * @param {Date} dataCadastro Data de inclusão do avaliador
     * @param {Date} dataAlteracao Data da última alteração do avaliador
     */
    constructor(id, nome, email, telefone, senha, permissoes, empresa, dataCadastro, dataAlteracao) {
        /** @member {Number} id Identificação do avaliador */
        this.id = id ?? null;
        /** @member {String} nome Nome do avaliador */
        this.nome = nome ?? null;
        /** @member {String} email Email do avaliador */
        this.email = email ?? null;
        /** @member {String} telefone Telefone do avaliador */
        this.telefone = telefone ?? null;
        /** @member {String} senha Senha do avaliador */
        this.senha = senha ?? null;
        /** @member {Array<Permissao>} permissoes Lista de permissões do avaliador */
        this.permissoes = permissoes ?? [ ];
        /** @member {Empresa} empresa Empresa relacionada ao avaliador */
        this.empresa = empresa ?? null;
        /** @member {Date} dataCadastro Data de inclusão do avaliador */
        this.dataCadastro = dataCadastro ?? null;
        /** @member {Date} dataAlteracao Data da última alteração do avaliador */
        this.dataAlteracao = dataAlteracao ?? null;
    }

    /**
     * Copia os dados de um objeto
     * @param {Avaliador} avaliador Objeto a ser clonado
     * @returns {Avaliador} Retorna um novo objeto com os mesmos dados
     */
    static clone(avaliador) {
        //Copia a lista de permissões
        let permissoes = null;
        if (avaliador.permissoes)
            permissoes = avaliador.permissoes.map(permissao => Permissao.clone(permissao));

        //Copia os dados da empresa
        let empresa = null;
        if (avaliador.empresa)
            empresa = Empresa.clone(avaliador.empresa);

        return new Avaliador(avaliador.id, avaliador.nome, avaliador.email, avaliador.telefone, avaliador.senha, permissoes, empresa, avaliador.dataCadastro, avaliador.dataAlteracao);
    }
}

export default Avaliador;